import Counter from "./Counter";

const ProgressBar = ({ value, color, extraCls, withoutCounter }) => {
  return (
    <div
      className={`progress-bar-container ${extraCls ? extraCls : ""}`}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        fontSize: "48px", // Larger text size for emphasis
        fontWeight: "bold",
        color: color || "#4CAF50", // Default color is green
        textAlign: "center",
      }}
    >
      {/* Display the counter or value */}
      <div>
        {withoutCounter ? (
          <span>{value}</span>
        ) : (
          <span>
            <Counter end={value} />
            <span>+</span>
          </span>
        )}
      </div>

      {/* Optional label */}
      <div
        style={{
          fontSize: "16px",
          fontWeight: "normal",
          color: "#666", // Subtle gray for the label
          marginTop: "8px",
        }}
      >
        {/* Progress */}
      </div>
    </div>
  );
};

export default ProgressBar;
